import { useContext } from "react";
import {
    HStack, 
    Image, 
    Text, 
    Button, 
    Icon 
} from "@chakra-ui/react";
import { FaTrashAlt } from "react-icons/fa";
import { CartContext } from "../../../context/CartContext";

const CartList = () => {
    const { cart, cleanItem } = useContext(CartContext);

    return (
        cart.map(item => (
            <HStack 
                borderBottom="1px" 
                borderColor="gray.300"
                justifyContent="space-around"
                key={item.id}
                w="full"
            >
                <HStack w="50%" justifyContent="space-around">
                    <Button 
                        variant="ghost" 
                        onClick={() => cleanItem(item.id)}
                    >
                        <Icon as={FaTrashAlt}/>
                    </Button>
                    <Image src={item.img} w="10rem"></Image>
                    <Text>{item.brand} {item.model}</Text>
                </HStack>
                <Text 
                    w="25%"
                    textAlign="center"
                >{item.count}
                </Text>
                <Text 
                    w="25%"
                    textAlign="center"
                >${(item.price * item.count).toFixed(2)}
                </Text>
            </HStack>
        ))
    );
}

export default CartList